<div class="main-content full-screen registration-modal">
  <div class="full-height-page" style="height: calc(100vh - 56px) !important;">
    <div class="text-center">Oops... maaf kamu belum bisa melihat detail produk dan berbelanja jika belum melengkapi profil</div>
  </div>
</div>
